import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import React, { useState } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";

const EnquireForm = () => {
const {packageEnquriToggle, safariPackagesDispatch} = useSafariPackagesContext();
 const [travelers, setTravelers] = useState(0);

 const handleClose = () =>{
  safariPackagesDispatch({ type: "SET_PACKAGE_ENQURI_FORM_TOGGLE", payload: true });
 }
  return (
    <Modal show={packageEnquriToggle} onHide={handleClose} centered>
      <div className="enquire-modal">
        <h4 className="modal-title-custom">ENQUIRE</h4>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col md={3}>
                <div className="input-group2">
                  <Form.Label>Travelers</Form.Label>
                  <div className="number-input position-relative">
                    <Form.Control type="text" value={travelers} readOnly />
                    <div className="bton_updown">
                      <button
                        type="button"
                        onClick={() => setTravelers(travelers + 1)}
                      >
                        <i className="fa-solid fa-chevron-up"></i>
                      </button>
                      <button
                        type="button"
                        onClick={() =>
                          setTravelers((prev) => Math.max(prev - 1, 0))
                        }
                      >
                        <i className="fa-solid fa-chevron-down"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <Form.Label>Start Date</Form.Label>
                <Form.Control type="date" />
              </Col>
              <Col md={4}>
                <Form.Label>End Date</Form.Label>
                <Form.Control type="date" />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Full Name</Form.Label>
                <Form.Control type="text" placeholder="Your name" />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Email Address</Form.Label>
                <Form.Control type="email" placeholder="xyz@abc.com" />
              </Col>
              <Col md={6}>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control type="tel" placeholder="+91" />
              </Col>
            </Row>

            <div className="d-flex justify-content-between">
              <Form.Group
                controlId="terms"
                className="mb-3 d-flex align-items-center"
              >
                <Form.Check type="checkbox" />
                <span className="ms-2 terms-text">
                  <i>I agree to the terms and conditions.</i>
                </span>
              </Form.Group>

              <div className="">
                <Button type="submit" className="send-request-btn">
                  Send Request
                </Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default EnquireForm;
